var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnersSquareIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 299,
    viewBox: "0 0 179 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.065 150.255L101.526 230.961L19.3775 82.7333L81.7004 17.8777L155.065 150.255Z",
    fill: "#5056FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-29.7766 255.263L-101.351 126.116L-20.5992 58.5917L81.7108 17.9516L19.071 82.0042L101.372 230.506L-29.7766 255.263Z",
    fill: "url(#paint0_angular_658_283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_658_283",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.383 52.7458) rotate(160.102) scale(246.769 263.583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000797948,
    stopColor: "#676CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADAFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersSquareIc);
export default __webpack_public_path__ + "static/media/partnersSquare_ic.5a4cbf2d5c62997ff434a3ff4bf0b516.svg";
export { ForwardRef as ReactComponent };